import React from 'react';
import Swiper from 'react-id-swiper';

import cust01 from '../images/cust/cust-01.png'
import cust02 from '../images/cust/cust-02.png'
import cust03 from '../images/cust/cust-03.png'
import cust04 from '../images/cust/cust-04.png'
// import cust05 from '../images/cust/cust-05.png'
import cust06 from '../images/cust/cust-06.png'
import cust07 from '../images/cust/cust-07.png'
import cust08 from '../images/cust/cust-08.png'
import cust09 from '../images/cust/cust-09.png'
import cust10 from '../images/cust/cust-10.png'
import cust11 from '../images/cust/cust-11.png'
import cust12 from '../images/cust/cust-12.png'

import './customers.styl'
// import Swiper from 'react-id-swiper/lib/custom';

class SwiperCustomers extends React.Component {
  render() {
    const params = {
		slidesPerView: 5,
		spaceBetween: 50,
		direction: 'horizontal',
		freeMode: true, 
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			loop: true
		},
    }

    return(
      <Swiper {...params}>
        <div><img src={cust01} alt=""/></div>
        <div><img src={cust02} alt=""/></div>
        <div><img src={cust04} alt=""/></div>
        <div><img src={cust06} alt=""/></div>
        <div><img src={cust08} alt=""/></div>
        <div><img src={cust09} alt=""/></div>
        <div><img src={cust03} alt=""/></div>
        <div><img src={cust07} alt=""/></div>
        <div><img src={cust10} alt=""/></div>
        <div><img src={cust11} alt=""/></div>
        <div><img src={cust12} alt=""/></div>
      </Swiper>
    )
  }
}

export default SwiperCustomers;


// WEBPACK FOOTER //
// ./src/components/customers.js